import React from 'react';
import { ICurrentCategoryData } from '../cus-product-list.data';
import useCategoryNavigation from '../hooks/useCategoryNavigation';

export default function CategoryNavigation({ response, subCategoriesAriaLabel }: ICurrentCategoryData) {
    const { containerRef, currentCategory, categoriesFamily, parentCategory } = useCategoryNavigation({ response });

    return (
        <nav aria-label={subCategoriesAriaLabel} className='bs-subcategory__nav'>
            {!!parentCategory?.ParentCategory && (
                <a className='bs-subcategory__parent' href={parentCategory.Url}>
                    <span aria-hidden='true'>←</span>
                    <span>{parentCategory.Name}</span>
                </a>
            )}
            <ul className='bs-subcategory__container' ref={containerRef}>
                <li className='bs-subcategory__item --active' key={currentCategory?.RecordId}>
                    <span aria-current='page'>{currentCategory?.Name}</span>
                </li>

                {categoriesFamily?.length > 0 &&
                    categoriesFamily.map(category => {
                        if (category.Name === currentCategory?.Name) {
                            return null;
                        }

                        return (
                            <li className='bs-subcategory__item' key={category.RecordId}>
                                <a href={category.Url}>{category.Name}</a>
                            </li>
                        );
                    })}
            </ul>
        </nav>
    );
}
